function getBaseBackendUrl(): string {
  let url = "";
  const host = window.location.hostname;

  switch (host) {
    case "localhost":
      url = "https://ibank-api-test.qore.build";
      break;
    case "ibank-admin-test.qore.build":
      url = "https://ibank-api-test.qore.build";
      break;
    case "ibank-adminportal-staging.qore.build":
      url = "https://ibank-staging.qore.build";
      break;
    default:
      url = "https://api.qoreonline.com";
      break;
  }

  return url;
}

export const url = {
  BASE_URL: `${getBaseBackendUrl()}/api`,
  CUSTOMER_SERVICE_URL: `${getBaseBackendUrl()}/customer-service/api/v1`,
};

export const appSettings = {
  SESSION_EXPIRATION_LENGTH: 3,
  INACTIVITY_TIME: 1000 * 60 * 3,
};

export const downloadLimitMsg = `The report you have requested exceeds the maximum of 2,000 records.
Please view the report and adjust the filter to view any missing records you might need`;

const mfbRoutesData = [
  {
    title: "Theme Design",
    path: "/dashboard/app-design",
    menuCategory: "appConfig",
  },
  {
    title: "Application Details",
    path: "/dashboard/app-details",
    menuCategory: "appConfig",
  },
  {
    title: "Onboarding Slides",
    path: "/dashboard/onboarding-slides",
    menuCategory: "appConfig",
  },
  {
    title: "Configuration",
    path: "/dashboard/configuration",
    menuCategory: "appConfig",
  },
  {
    title: "Feature Control",
    path: "/dashboard/feature-control",
    menuCategory: "appConfig",
  },
  {
    title: "App Generation",
    path: "/dashboard/app-generation",
    menuCategory: "appConfig",
  },
  {
    title: "Web Banking",
    path: "/dashboard/ibanking-feed",
    menuCategory: "feedManagement",
  },
  {
    title: "Mobile Banking",
    path: "/dashboard/mbanking-feed",
    menuCategory: "feedManagement",
  },
  {
    title: "Notification",
    path: "/dashboard/notification",
    menuCategory: "feedManagement",
  },
  {
    title: "Customer Login",
    path: "/dashboard/customer-login-report",
    menuCategory: "reports",
  },
  {
    title: "Failed Transactions",
    path: "/dashboard/failed-tx-report",
    menuCategory: "reports",
  },
  {
    title: "Transfer",
    path: "/dashboard/transfer-report",
    menuCategory: "reports",
  },
  {
    title: "Cross Border Payment",
    path: "/dashboard/cross-border-report",
    menuCategory: "reports",
  },
  {
    title: "Bills payment",
    path: "/dashboard/bill-payment-report",
    menuCategory: "reports",
  },
  {
    title: "Airtime",
    path: "/dashboard/airtime-report",
    menuCategory: "reports",
  },
  {
    title: "Transaction Limit",
    path: "/dashboard/tx-limit-report",
    menuCategory: "reports",
  },
  {
    title: "Fixed Deposit",
    path: "/dashboard/fixed-deposit-report",
    menuCategory: "reports",
  },
  {
    title: "Cardless Withrawals",
    path: "/dashboard/cardless-withdrawal-report",
    menuCategory: "reports",
  },
  {
    title: "Loans",
    path: "/dashboard/loans-report",
    menuCategory: "reports",
  },
  {
    title: "Target Savings",
    path: "/dashboard/target-savings-report",
    menuCategory: "reports",
  },
  {
    title: "Customer Profile",
    path: "/dashboard/customer-profile-report",
    menuCategory: "customers",
  },
  {
    title: "Account Upgrade",
    path: "/dashboard/account-upgrade-requests",
    menuCategory: "customers",
  },
  {
    title: "Account Upgrade Details",
    path: "/dashboard/account-upgrade-details",
    menuCategory: "customers",
  },
  {
    title: "Cross Border Customer",
    path: "/dashboard/cross-border-customer",
    menuCategory: "customers",
  },
  {
    title: "Non Nigerian Account Opening Request",
    path: "/dashboard/non-nigerian-account-request",
    menuCategory: "customers",
  },
  {
    title: "Non Nigerian Account Opening Details",
    path: "/dashboard/non-nigerian-account-opening-details",
    menuCategory: "customers",
  },
  {
    title: "Audit Reports",
    path: "/dashboard/audit-report",
    menuCategory: "audit",
  },
  {
    title: "Login Reports",
    path: "/dashboard/login-report",
    menuCategory: "audit",
  },
  {
    title: "Users",
    path: "/dashboard/users",
    menuCategory: "users",
  },
  {
    title: "User Profile",
    path: "/dashboard/user-profile",
    menuCategory: "",
  },
  {
    title: "Audit Report Details",
    path: "/dashboard/audit-report/details",
    menuCategory: "audit",
  },
  {
    title: "FAQs",
    path: "/dashboard/faqs",
    menuCategory: "faqs",
  },
];

export const dashboardRoutesData = {
  Admin: mfbRoutesData,
  User: mfbRoutesData,
  SA: [
    {
      title: "Institutions",
      path: "/dashboard/institutions",
      menuCategory: "institutions",
    },
    {
      title: "Audit Reports",
      path: "/dashboard/audit-report",
      menuCategory: "audit",
    },
    {
      title: "Login Reports",
      path: "/dashboard/login-report",
      menuCategory: "audit",
    },
    {
      title: "Institutions",
      path: "/dashboard/institution-details",
      menuCategory: "institutions",
    },
    {
      title: "Users",
      path: "/dashboard/users",
      menuCategory: "users",
    },
    {
      title: "Build Settings",
      path: "/dashboard/build-configuration",
      menuCategory: "configuration",
    },
    {
      title: "Build Generation",
      path: "/dashboard/build-generation",
      menuCategory: "configuration",
    },
    {
      title: "User Profile",
      path: "/dashboard/user-profile",
      menuCategory: "",
    },
    {
      title: "Audit Report Details",
      path: "/dashboard/audit-report/details",
      menuCategory: "audit",
    },
    {
      title: "App Generation Report",
      path: "/dashboard/app-generation-report",
      menuCategory: "audit",
    },
    {
      title: "FAQs",
      path: "/dashboard/faqs",
      menuCategory: "faqs",
    },
    {
      title: "SurveyReport",
      path: "/dashboard/survey-report",
      menuCategory: "survey-report",
    },
    {
      title: "ManageSurvey",
      path: "/dashboard/survey-management",
      menuCategory: "survey-management",
    },
    {
      title: "SurveyDetails",
      path: "/dashboard/survey-details",
      menuCategory: "survey-details",
    },
    {
      title: "Run Migration",
      path: "/dashboard/run-migration",
      menuCategory: "migration",
    },
  ],
};

export const menuCategory = {
  appConfig: [
    "/dashboard/app-design",
    "/dashboard/app-details",
    "/dashboard/onboarding-slides",
    "/dashboard/configuration",
    "/dashboard/feature-control",
    "/dashboard/app-generation",
  ],
  feedManagement: [
    "/dashboard/ibanking-feed",
    "/dashboard/mbanking-feed",
    "/dashboard/notification",
  ],
  reports: [
    "/dashboard/customer-login-report",
    "/dashboard/failed-tx-report",
    "/dashboard/transfer-report",
    "/dashboard/bill-payment-report",
    "/dashboard/airtime-report",
    "/dashboard/tx-limit-report",
    "/dashboard/fixed-deposit-report",
    "/dashboard/cardless-withdrawal-report",
    "/dashboard/loans-report",
    "/dashboard/target-savings-report",
    "/dashboard/cross-border-report",
  ],
  customers: [
    "/dashboard/customer-profile-report",
    "/dashboard/user-profile",
    "/dashboard/account-upgrade-requests",
    "/dashboard/account-upgrade-details",
    "/dashboard/cross-border-customer",
    "/dashboard/non-nigerian-account-request",
    "/dashboard/non-nigerian-account-opening-details",
  ],
  audit: [
    "/dashboard/audit-report",
    "/dashboard/login-report",
    "/dashboard/audit-report/details",
    "/dashboard/app-generation-report",
  ],
  configuration: [
    "/dashboard/build-configuration",
    "/dashboard/build-generation",
  ],
  faqs: ["/dashboard/faqs"],
  survey: [
    "/dashboard/survey-report",
    "/dashboard/survey-management",
    "/dashboard/survey-details",
  ],
  migration: ["/dashboard/run-migration"],
};
